import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import Styleguide from "@/pages/Styleguide";

export const Route = createFileRoute("/styleguide")({
  component: StyleguideRoute,
});

function StyleguideRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Styleguide />
      </Suspense>
    </PageTransition>
  );
}
